import { VALIDATION } from '../constants';

export function validateCodicePersona(codicePersona: string): boolean {
  return codicePersona.length >= VALIDATION.CODICE_PERSONA_MIN_LENGTH && /^\d+$/.test(codicePersona);
}

export function validatePassword(password: string): boolean {
  return password.length >= VALIDATION.PASSWORD_MIN_LENGTH;
}

export function validateGroupName(name: string): boolean {
  return name.length >= VALIDATION.GROUP_NAME_MIN_LENGTH &&
         name.length <= VALIDATION.GROUP_NAME_MAX_LENGTH &&
         name.trim().length > 0;
}

export function validateInviteCode(code: string): boolean {
  return code.length === VALIDATION.INVITE_CODE_LENGTH && /^[A-Z0-9]+$/.test(code);
}

export function validateEmail(email: string): boolean {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

export function sanitizeInput(input: string): string {
  return input.trim().replace(/[<>]/g, '');
}

export function isValidUrl(url: string): boolean {
  try {
    new URL(url);
    return true;
  } catch {
    return false;
  }
}